/**
 * 使用 value 取交换 label
 * @param {string|number} val
 * @param {array} list list 的数据格式必须跟 [{value: 1, label: '我是label'}] 一致
 * @return {string|number} 如果没有找到 label，返回 undefined
 */
// eslint-disable-next-line consistent-return
export default function useValueExchangeLabel(val, list) {
  const temp = list.filter(item => item.value === val)
  if (temp.length > 0) return temp[0].label
}
